import AxiosConfig from '../utils/AxiosConfig';

class CoreBillingService {
  async getMyPaymentStatus() {
    const response = await AxiosConfig.get('/core-billing/my-payment-status');
    return response.data.data;
  }
}

export default new CoreBillingService();
